<div class="ag-filter">
  <div>
    <div class="ag-filter-body-wrapper">
      <div ref="ag-filter-loading" class="loading-filter ag-hidden">
        Loading...
      </div>
      <div>
        <!-- <div class="ag-filter-header-container" (click)="toggleEverything()">
          <div id="selectAllContainer">
            <div id="selectAll" class="ag-filter-checkbox">
              <mat-icon color="accent" *ngIf="isEverythingSelected"
                >check_box</mat-icon
              >
              <mat-icon color="accent" *ngIf="!isEverythingSelected">
                check_box_outline_blank
              </mat-icon>
              <span class="ag-filter-value">{{ 'selectAll' | translate }}</span>
            </div>
          </div>
        </div> -->
        <div style="display: flex; width: 100%; height: 100%; justify-content: center;">
          <mat-form-field style='margin-top: 3vh;' appearance="outline">
            <input matInput (keyup)="onFilterTextChanged($event)" />
            <!-- <button mat-icon-button matSuffix (click)="resetSearch()">
              <mat-icon> remove </mat-icon>
            </button> -->
          </mat-form-field>
        </div>
        <button mat-stroked-button (click)="selectAll()" style="margin: 1vh 1vw 1vh 1vw">
          {{ 'selectAll' | translate }}
        </button>
        <button mat-stroked-button (click)="deselectAll()" style="margin: 1vh 1vw 1vh 0vw">
          {{ 'deselectAll' | translate }}
        </button>
        <div style="width: 100%"></div>
        <mat-divider></mat-divider>
        <mat-list class="filter-list" dense>
          <mat-list-item
            *ngFor="let item of filteredItems$ | async"
            (click)="toggleItem(item)"
          >
            <mat-icon
              style="cursor: pointer; margin: 0vh 0.5vw 0vh 0vw;"
              color="accent"
              *ngIf="selectedValuesMap[item]"
              >check_box</mat-icon
            >
            <mat-icon
              style="cursor: pointer; margin: 0vh 0.5vw 0vh 0vw;"
              color="accent"
              *ngIf="!selectedValuesMap[item]"
            >
              check_box_outline_blank
            </mat-icon>
            <span *ngIf="!isBooleanFilter" class="ag-filter-value">{{
              item
            }}</span>
            <span *ngIf="isBooleanFilter" class="ag-filter-value">{{
              item | translate
            }}</span>
          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </div>
</div>

<!-- <div class="ag-filter">
  <div>
    <div class="ag-filter-body-wrapper">
      <div ref="ag-filter-loading" class="loading-filter ag-hidden">
        Loading...
      </div>
      <div>
        <div class="ag-filter-header-container" (click)="toggleEverything()">
          <label id="selectAllContainer">
            <mat-list-item id="selectAll" class="ag-filter-checkbox">
              <mat-icon matListIcon color="accent" *ngIf="isEverythingSelected"
                >check_box</mat-icon
              >
              <mat-icon
                matListIcon
                color="accent"
                *ngIf="!isEverythingSelected"
              >
                check_box_outline_blank
              </mat-icon>
              <span class="ag-filter-value">{{ 'selectAll' | translate }}</span>
            </mat-list-item>
          </label>
        </div>
        <mat-divider></mat-divider>
        <mat-list class="filter-list" dense>
          <mat-list-item
            *ngFor="let item of onFilterValuesChanged$ | async"
            (click)="toggleItem(item)"
          >
            <mat-icon matListIcon color="accent" *ngIf="selectedValuesMap[item]"
              >check_box</mat-icon
            >
            <mat-icon
              matListIcon
              color="accent"
              *ngIf="!selectedValuesMap[item]"
            >
              check_box_outline_blank
            </mat-icon>
            <span class="ag-filter-value">{{ item }}</span>
          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </div>
</div> -->
